/**
 * Price Type Switch (Brutto/Netto)
 * Centralized logic for switching all prices between gross (inkl. MwSt) and net (zzgl. MwSt).
 * Swiss VAT rate: 7.7%
 */

const PRICE_TYPE_CONFIG = {
  vatRate: 1.077,
  storageKey: 'priceOption',
  storageNameKey: 'priceOptionName',
  defaultOption: 'inkl',
};

const PRICE_SELECTORS = [
  '.price-item.price-item--regular',
  '.price-item.price-item--sale',
  '.cart-item .price--end',
  '.price-total-sum',
  '.totals__total-value',
].join(', ');

// One-time migration from sessionStorage to localStorage
(function () {
  var session = sessionStorage.getItem(PRICE_TYPE_CONFIG.storageKey);
  var local = localStorage.getItem(PRICE_TYPE_CONFIG.storageKey);
  if (session && !local) {
    localStorage.setItem(PRICE_TYPE_CONFIG.storageKey, session);
    var name = sessionStorage.getItem(PRICE_TYPE_CONFIG.storageNameKey);
    if (name) localStorage.setItem(PRICE_TYPE_CONFIG.storageNameKey, name);
  }
  sessionStorage.removeItem(PRICE_TYPE_CONFIG.storageKey);
  sessionStorage.removeItem(PRICE_TYPE_CONFIG.storageNameKey);
})();

function getStoredPriceOption() {
  return localStorage.getItem(PRICE_TYPE_CONFIG.storageKey) || PRICE_TYPE_CONFIG.defaultOption;
}

function storePriceOption(option, name) {
  localStorage.setItem(PRICE_TYPE_CONFIG.storageKey, option);
  localStorage.setItem(PRICE_TYPE_CONFIG.storageNameKey, name);
}

function changePrice(option) {
  if (!option) return;

  if (option === 'zzgl') {
    document.body.classList.add('netto');
    document.body.classList.remove('brutto');
  } else {
    document.body.classList.remove('netto');
    document.body.classList.add('brutto');
  }

  document.querySelectorAll(PRICE_SELECTORS).forEach(function (el) {
    var priceText = el.textContent.trim();
    var match = priceText.match(/([\D]*)([\d,\.]+)([\D]*)/);
    if (!match) return;

    var prefix = match[1];
    var rawPrice = match[2];
    var priceValue;
    if (rawPrice.indexOf('.') !== -1 && rawPrice.indexOf(',') !== -1) {
      if (rawPrice.indexOf(',') < rawPrice.indexOf('.')) {
        // English format: "2,499.00" — comma=thousands, dot=decimal
        priceValue = parseFloat(rawPrice.replace(/,/g, ''));
      } else {
        // German format: "2.499,00" — dot=thousands, comma=decimal
        priceValue = parseFloat(rawPrice.replace(/\./g, '').replace(',', '.'));
      }
    } else if (rawPrice.indexOf(',') !== -1) {
      // Only comma: decimal separator "12,50"
      priceValue = parseFloat(rawPrice.replace(',', '.'));
    } else {
      // Only dot or plain integer: "12.50"
      priceValue = parseFloat(rawPrice);
    }
    var suffix = match[3];
    if (isNaN(priceValue)) return;

    if (option === 'zzgl') {
      if (!el.dataset.originalPrice) {
        el.dataset.originalPrice = priceValue.toFixed(2);
        el.dataset.originalText = priceText;
      } else {
        priceValue = parseFloat(el.dataset.originalPrice);
      }
      el.textContent = prefix + (priceValue / PRICE_TYPE_CONFIG.vatRate).toFixed(2).replace('.', ',') + suffix;
    } else {
      if (el.dataset.originalPrice) {
        el.textContent = el.dataset.originalText || prefix + parseFloat(el.dataset.originalPrice).toFixed(2).replace('.', ',') + suffix;
      }
    }
  });

  syncDropdowns(option);
}

function syncDropdowns(option) {
  document.querySelectorAll('.custom-dropdown').forEach(function (dropdown) {
    var selectedOption = dropdown.querySelector('.selected-option');
    var targetLi = dropdown.querySelector('.dropdown-li[data-value="' + option + '"]');
    if (selectedOption && targetLi) {
      selectedOption.textContent = targetLi.textContent;
    }
  });

  document.querySelectorAll('.checkmark').forEach(function (cm) {
    cm.classList.add('od-hidden');
  });
  document.querySelectorAll('.dropdown-li').forEach(function (item) {
    if (item.dataset.value === option) {
      var checkmark = item.previousElementSibling;
      if (checkmark && checkmark.classList.contains('checkmark')) {
        checkmark.classList.remove('od-hidden');
      }
    }
  });
}

// Apply stored preference on page load
document.addEventListener('DOMContentLoaded', function () {
  changePrice(getStoredPriceOption());
});

// Re-apply after cart HTML replacement
if (typeof subscribe === 'function') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    setTimeout(function () {
      changePrice(getStoredPriceOption());
    }, 100);
  });
}

// Expose globally for backward compatibility
window.changePrice = changePrice;
window.getStoredPriceOption = getStoredPriceOption;
window.storePriceOption = storePriceOption;
